import { Stack, Text } from '@fluentui/react'
import { LatencyPercentiles } from '../../api/models'
import StatCard from '../common/StatCard'
import PerformancePanel from './PerformancePanel'
import { formatSeconds } from './performanceFormat'

type LatencyTilesProps = {
  answerCount: number
  latency: LatencyPercentiles
}

const LatencyTiles = ({ answerCount, latency }: LatencyTilesProps) => {
  if (answerCount === 0) {
    return (
      <PerformancePanel title="Answer latency" isEmpty emptyMessage="No completed answers recorded for this period." />
    )
  }

  return (
    <Stack horizontal tokens={{ childrenGap: 16 }} styles={{ root: { flexWrap: 'wrap' } }}>
      <StatCard title="Completed answers" value={answerCount.toLocaleString()} color="#2B3A67">
        <Text variant="small" styles={{ root: { color: '#605e5c' } }}>
          Excludes abandoned answers
        </Text>
      </StatCard>
      <StatCard title="p50 answer time" value={formatSeconds(latency.p50_ms)} color="#496A99" />
      <StatCard title="p90 answer time" value={formatSeconds(latency.p90_ms)} color="#496A99" />
      <StatCard title="p95 answer time" value={formatSeconds(latency.p95_ms)} color="#8BACC4" />
      <StatCard title="p99 answer time" value={formatSeconds(latency.p99_ms)} color="#8BACC4" />
    </Stack>
  )
}

export default LatencyTiles
